import {
  Box,
  Fade,
  Modal,
  Grid,
  Button,
  useMediaQuery,
  Divider,
  Checkbox,
  styled,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Close } from "@mui/icons-material";
import theme from "../../config/theme";
import {
  getImageSrc,
  formattedAmountWithoutAed,
} from "../../utils/CommonFunction";
import _, { isEmpty } from "lodash";
import { getNewApiData } from "../../utils/APIHelper";
import { toast } from "react-toastify";
import styles from "./styles";
import { ReactComponent as NewDesignIcon } from "../../assets/svg/NewDesignIcon.svg";
import { ReactComponent as SmallDhiramIcon } from "../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../utils/CurrencyUtils";

import CAutocomplete from "../CAutocomplete";

const errorObj = {
  groupNameError: false,
  groupNameMsg: "",
};

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#4D6BF6",
  color: "#ffffff",
  boxShadow: "none",
  border: "1px solid #4D6BF6",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const GreyStyledButton = styled(Button)(({ theme }) => ({
  background: "#fff",
  color: "#0D0D0E",
  boxShadow: "none",
  border: "1px solid #D7D8D9",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

function PackageGroupModal({
  isCreationOpen,
  visible,
  handleCloseCreation,
  selectedPackageGroup,
  isEdit,
  inclusions,
  packageGroups,
  packageId,
  getProjectDetails,
}) {
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const md = useMediaQuery(theme.breakpoints.down("md"));

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: sm ? 300 : 750,
    bgcolor: "background.paper",
    borderRadius: 1,
    boxShadow: 24,
    p: "2vh 2vw",
    fontFamily: "Inter Tight",
  };
  const [errObj, setErrObj] = useState(errorObj);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [packageGroupDetails, setPackageGroupDetails] = useState({
    groupName: "",
    groupBy: "NONE",
  });

  console.log("inclusions", inclusions, "packageGroups", packageGroups);
  const [selectedInclusions, setSelectedInclusions] = useState([]);
  const [groupBy, setGroupBy] = useState("NONE");
  const groupByOptions = ["NONE", "Layout"];
  const groupNameOptions = ["Default", "Studio", "1 BR", "2 BR"];

  const assignedInclusionIds = packageGroups.flatMap(
    (pg) => pg.inclusions?.map((i) => i.id) || []
  );

  const assignedInclusionsInThisGroup = isEdit
    ? selectedPackageGroup?.inclusions || []
    : [];

  const unassignedInclusions = inclusions?.filter(
    (incl) => !assignedInclusionIds.includes(incl.id)
  );

  const allInclusions = [
    ...assignedInclusionsInThisGroup,
    ...unassignedInclusions,
  ];

  useEffect(() => {
    if (isEdit && selectedPackageGroup) {
      setSelectedInclusions(selectedPackageGroup.inclusions.map((i) => i.id));
    }
  }, [isEdit, selectedPackageGroup]);

  const handleInclusionSelection = (id) => {
    setSelectedInclusions((prevSelected) => {
      return prevSelected.includes(id)
        ? prevSelected.filter((inclId) => inclId !== id)
        : [...prevSelected, id];
    });
  };

  const submitPackageGroup = async (data, isEditFlag) => {
    console.log("Data", data);
    setButtonLoader(true);
    try {
      const method = isEditFlag ? "PUT" : "POST";

      const endpoint = isEditFlag
        ? `api/v2/package/${packageId}/groups/${selectedPackageGroup?.id}`
        : `api/v2/package/${packageId}/groups`;

      const response = await getNewApiData(
        endpoint,
        method,
        data,
        { "Content-Type": "application/json" },
        true
      );

      if (response) {
        toast.success(
          isEditFlag
            ? "Package Group Updated Successfully"
            : "Package Group Added Successfully"
        );
        getProjectDetails(packageId);
      }
    } catch (error) {
      toast.error(error.toString());
    } finally {
      setButtonLoader(false);
    }
  };

  const validate = () => {
    const error = { ...errObj };
    let valid = true;

    if (isEmpty(packageGroupDetails?.groupName)) {
      valid = false;
      error.groupNameError = true;
      error.groupNameMsg = "Please enter the name";
    }

    if (!selectedInclusions || selectedInclusions.length === 0) {
      toast.error("Please select at least one inclusion to proceed");
      return;
    }

    setErrObj(error);

    if (valid) {
      handleCloseCreation();

      const body = {
        name: packageGroupDetails?.groupName,
        groupBy: packageGroupDetails?.groupBy,
        packageId: parseInt(packageId),
        ...(isEdit ? { id: selectedPackageGroup?.id } : {}),
        inclusions: selectedInclusions.map((id) => ({
          id: id,
        })),
      };

      console.log("body", body);
      submitPackageGroup(body, isEdit);
    }
  };

  useEffect(() => {
    console.log("miles", inclusions, packageGroups);
    if (selectedPackageGroup) {
      console.log("selectedM", selectedPackageGroup);
      setPackageGroupDetails({
        groupName: selectedPackageGroup?.group_name || "Default",
        groupBy: selectedPackageGroup?.group_by || "NONE",
      });
    }
  }, [selectedPackageGroup]);

  return (
    <>
      <Modal open={isCreationOpen || visible} onClose={handleCloseCreation}>
        <Fade in={isCreationOpen || visible}>
          <Box sx={style}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="addMilestoneHeader">
                {isEdit ? "Update" : "Add"} Package Group
              </div>
              <Close
                style={{ cursor: "pointer" }}
                onClick={() => handleCloseCreation()}
              />
            </div>
            <Grid container>
              <Grid
                item
                container
                columnGap={2}
                wrap={md ? "wrap" : "nowrap"}
                mt={2}
              >
                <Grid item xs={12} md={6} mb={2}>
                  <CAutocomplete
                    label={<span>Group By</span>}
                    options={groupByOptions}
                    value={packageGroupDetails.groupBy}
                    onChange={(_, newValue) => {
                      const newGroupBy = newValue || "NONE";
                      setPackageGroupDetails((prev) => {
                        const updatedGroupName =
                          newGroupBy === "NONE"
                            ? "Default"
                            : prev.groupName === "Default"
                              ? "Studio"
                              : prev.groupName;
                        return {
                          ...prev,
                          groupBy: newGroupBy,
                          groupName: updatedGroupName,
                        };
                      });
                    }}
                    error={errObj.groupNameError}
                    helpertext={errObj.groupNameMsg}
                  />
                </Grid>
                <Grid item xs={12} md={6} mb={2}>
                  <CAutocomplete
                    label={<span>Group Name</span>}
                    options={groupNameOptions}
                    value={packageGroupDetails.groupName}
                    onChange={(_, newValue) => {
                      const newGroupName = newValue || "Default";
                      setPackageGroupDetails((prev) => {
                        const updatedGroupBy =
                          newGroupName === "Default"
                            ? "NONE"
                            : prev.groupBy === "NONE"
                              ? "Layout"
                              : prev.groupBy;
                        return {
                          ...prev,
                          groupName: newGroupName,
                          groupBy: updatedGroupBy,
                        };
                      });
                      setErrObj({
                        ...errObj,
                        groupNameError: false,
                        groupNameMsg: "",
                      });
                    }}
                    error={errObj.groupNameError}
                    helpertext={errObj.groupNameMsg}
                  />
                </Grid>
              </Grid>
            </Grid>

            {allInclusions?.length > 0 && (
              <>
                <div
                  style={{
                    ...styles.columnFlex,
                    gap: "10px",
                    maxHeight: "40vh",
                    overflowY: "scroll",
                    scrollbarWidth: "none",
                  }}
                >
                  {allInclusions?.map((inclusion) => (
                    <div style={styles.budgetRow} key={inclusion.id}>
                      <div style={{ ...styles.rowFlex, flex: 2 }}>
                        <Box display="flex" alignItems="center" gap="10px">
                          <Checkbox
                            checked={selectedInclusions.includes(inclusion.id)}
                            onChange={() =>
                              handleInclusionSelection(inclusion.id)
                            }
                          />
                          <span
                            style={{
                              ...styles.small_sub_heading,
                              ...styles.rowFlex,
                              gap: "0px",
                              marginLeft: "1vw",
                            }}
                          >
                            <Box
                              component="img"
                              src={getImageSrc(inclusion?.image?.path)}
                              alt="Inclusion Icon"
                              sx={{
                                width: 35,
                                height: 35,
                                borderRadius: "8px",
                                border: "2px solid white",
                                boxShadow: "0px 4px 2.67px 0px #00000026",
                                marginRight: 0.7,
                              }}
                            />
                            {inclusion?.name}
                          </span>
                        </Box>
                      </div>

                      <div
                        style={{ ...styles.columnFlex, flex: 1, gap: "7px" }}
                      >
                        <div
                          style={{
                            ...styles.small_sub_heading,
                            ...styles.rowFlex,
                            gap: "8px",
                          }}
                        >
                          <NewDesignIcon />
                          {inclusion?.materialType}
                        </div>
                      </div>

                      <div style={{ ...styles.columnFlex, flex: 1 }}>
                        <h3 style={styles.small_text}>Cost</h3>
                        <div
                          style={{
                            ...styles.small_sub_heading,
                            ...styles.rowFlex,
                            gap: "5px",
                          }}
                        >
                          {inclusion?.cost && renderCurrencyIcon('small')}
                          {inclusion?.cost
                            ? formattedAmountWithoutAed(inclusion?.cost)
                            : "-"}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            <Divider style={{ marginTop: "2vh" }} />
            <Grid
              item
              container
              justifyContent="center"
              gap={sm ? 1 : 2}
              wrap="nowrap"
              marginTop="10px"
            >
              <Grid
                item
                xs={6}
                sx={{ display: "flex", justifyContent: "flex-start" }}
              >
                <GreyStyledButton onClick={handleCloseCreation}>
                  Cancel
                </GreyStyledButton>
              </Grid>

              <Grid
                item
                xs={6}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <StyledButton
                  variant="contained"
                  onClick={validate}
                  disabled={buttonLoader}
                >
                  {isEdit ? "Update" : "Add"} Package Group
                </StyledButton>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default PackageGroupModal;
